const questions = {
	1: {
		progress: 1,
		content: 'Lease Name',
		navigation: {
			navYes: '/rate-implicit-calculator/prompt/2',
			current: 1,
		},
		definition: {
			open: "Let's start by naming this lease.",
			phrase: '',
			close: '',
		},
	},
	2: {
		progress: 2,
		content: 'Lease Start Date',
		navigation: {
			navYes: '/rate-implicit-calculator/prompt/3',
			navDate: true,
		},
		definition: {
			open: 'Enter ',
			phrase: 'Lease Start',
			close: ' and End Dates.',
		},
		info: {
			infoAbbreviated: `
			<b>Lease Start</b><br /><br />
			The lease start date is the date the lessee takes possession of the underlying asset(s).`,
		},
	},
	3: {
		progress: 3,
		content: 'Fair Value',
		definition: {
			open: 'What is the ',
			phrase: 'Fair Value',
			close: ' of the Underlying Leased Asset at Lease Commencement?',
		},
		info: {
			infoAbbreviatedASC840: `
			<b>Fair Value</b><br /><br />
			Fair value is defined as the price that would be received to sell the underlying asset(s) in an orderly transaction 
			between market participants at the lease commencement date.
			<br /><br />
			Any investment tax credits retained and expected 
			to be realized by the lessor should be subtracted from the fair value.`,
			infoAbbreviatedASC842: `
			<b>Fair Value</b><br /><br />
			Fair value is defined as the price that would be received to sell the underlying asset(s) in an orderly transaction 
			between market participants at the lease commencement date.
			<br /><br />
			Any investment tax credits retained and expected 
			to be realized by the lessor should be subtracted from the fair value and any deferred initial direct costs of the 
			lessor should be added to the fair value.`,
			infoAbbreviatedGASB: `
			<b>Fair Value</b><br /><br />
			Fair value is defined as the price that would be received to sell the underlying asset(s) in an orderly transaction 
			between market participants at the lease commencement date. 
			<br /><br />
			Any investment tax credits retained and expected 
			to be realized by the lessor should be subtracted from the fair value and any initial direct costs of the 
			lessor should be added to the fair value.`,
			infoAbbreviatedIFRS: `
			<b>Fair Value</b><br /><br />
			Fair value is defined as the price that would be received to sell the underlying asset(s) in an orderly transaction 
			between market participants at the lease commencement date. 
			<br /><br />
			Any initial direct costs of the lessor should be added to the fair value.`,
		},
		navigation: {
			navYes: '/rate-implicit-calculator/prompt/4',
		},
	},
	4: {
		content: 'Payment Builder',
		definition: {
			paymentAmountTitle: 'Payment Amount',
			paymentFrequencyTitle: 'Payment Frequency',
			firstPaymentDateTitle: 'First Payment Date',
			numberOfPaymentsTitle: '# of Payments',
			lastPaymentDateTitle: 'Last Payment Date',
			escalationTitle: 'Escalation',
			escalationFrequencyTitle: 'Escalation Frequency',
		},
		progress: 4,
		navigation: {
			navYes: '/rate-implicit-calculator/prompt/5',
			navPayment: true,
		},
	},
	5: {
		content: 'Expected Residual Value',
		definition: {
			open: "What is the asset's ",
			phrase: 'Expected Residual Value ',
			close: ' at the end of the lease term?',
		},
		info: {
			infoAbbreviated: `
			<b>Expected Residual Value</b><br /><br />
			Expected residual value is the amount the lessor is expected to derive from the underlying asset(s) 
			at the end of the lease term. Inflation is normally not considered in determining this amount.`,
		},
		progress: 5,
		navigation: {
			navYes: '/rate-implicit-calculator/submit',
		},
	},
	submit: {
		definition: {
			open: 'Where would you like to receive results?',
			phrase: '',
			close: '',
			answer: '',
		},
		progress: 6,
	},
}

export default questions
